const isDev = process.env.NODE_ENV !== 'production';

export const logger = {
  log: (...args: any[]) => { if (isDev) console.log(...args); },
  warn: (...args: any[]) => { if (isDev) console.warn(...args); },
  error: (...args: any[]) => { if (isDev) console.error(...args); },
  // Always log critical errors even in production
  critical: (...args: any[]) => { console.error(...args); },
};
